import type { TaskStatus } from '../types/project';

export const TASK_STATUSES: TaskStatus[] = ['TO_DO', 'DOING', 'BLOCKED', 'COMPLETED', 'CANCELLED'];

export const STATUS_LABEL: Record<TaskStatus, string> = {
  TO_DO: 'Backlog',
  DOING: 'In Progress',
  BLOCKED: 'Blocked',
  COMPLETED: 'Done',
  CANCELLED: 'Cancelled',
};

export const STATUS_BADGE: Record<TaskStatus, { bg: string; color: string }> = {
  TO_DO:     { bg: 'var(--color-backlog-bg)',     color: 'var(--color-text-secondary)' },
  DOING:     { bg: 'var(--color-in-progress-bg)', color: 'var(--color-in-progress)' },
  BLOCKED:   { bg: 'var(--color-blocked-bg)',     color: 'var(--color-blocked)' },
  COMPLETED: { bg: 'var(--color-completed-bg)',   color: 'var(--color-green)' },
  CANCELLED: { bg: 'var(--color-cancelled-bg)',   color: 'var(--color-text-muted)' },
};
